import { Link } from 'react-router-dom';
import { Pictogram } from '@eti/components';
import { css } from '@eti/styles';
import type { HeadingTypes } from '@etg/wings';
import { breakpoints, Card, Heading, Inline, Stack, Text } from '@etg/wings';
import { useSiteContext, useSnowplowTracking, useTranslation } from '@eti/providers';
import { routes } from '../../../../constants/routesAndApisConstants';

const pictogramStyles = (shouldDisplayInline: boolean) => css`
  height: 100%;
  width: 100px;

  ${!shouldDisplayInline &&
  `@media (min-width: ${breakpoints._970}) {
    height: 153px;
    width: 100%;
    }`}
`;

const upgradeTripContentStyles = css`
  flex: 1;
`;

const upgradeTripStackStyles = (shouldDisplayInline: boolean) => css`
  ${!shouldDisplayInline &&
  `@media (min-width: ${breakpoints._970}) {
    align-items: start;
    flex-direction: column;
  }`}
`;

interface OrderDetailsUpgradeTripBannerProps {
  dataTestId: string;
  shouldDisplayInline: boolean;
  headingAs?: `h${HeadingTypes['level']}` | 'h5';
}

const OrderDetailsUpgradeTripBanner = ({
  dataTestId,
  shouldDisplayInline,
  headingAs = 'h2',
}: OrderDetailsUpgradeTripBannerProps) => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handleOnClick = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Manage Trip',
        action: 'Click',
        label: 'UPGRADE_TRIP',
      });
    }
  };

  return (
    <Card data-testid={`${dataTestId}-order-details-upgrade-trip-banner`} padding={16}>
      <Inline
        alignY="center"
        className={upgradeTripStackStyles(shouldDisplayInline)}
        noWrap
        spacing={16}
      >
        <Pictogram
          brand={brand.code}
          className={pictogramStyles(shouldDisplayInline)}
          id="extra-services"
        />
        <Stack align="start" className={upgradeTripContentStyles} spacing={8}>
          <Heading as={headingAs} level={2}>
            {t('MyBookingsWelcomePage.Banner.UpgradeTrip.Title')}
          </Heading>
          <Text>{t('MyBookingsWelcomePage.Banner.UpgradeTrip.Description')}</Text>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link onClick={handleOnClick} to={routes.ORDER_DETAILS_EXTRA_PRODUCTS}>
            {t('MyBookingsWelcomePage.Banner.UpgradeTrip.Link.Text')}
          </Link>
        </Stack>
      </Inline>
    </Card>
  );
};

export default OrderDetailsUpgradeTripBanner;
